import {HELP, DASHBOARD} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {lazy} from 'react'
import {AssetRoutes} from './asset.routes'
import {InventoryRoutes, LowStockRoutes} from './inventory.routes'
import {LicenseExpiryRoutes, LicenseRoutes} from './license.routes'
import {MasterdataRoutes} from './masterdata.routes'
import {NotificationRoutes} from './notification.routes'
import {ProcurementRoutes} from './procurement.routes'
import {ReportRoutes} from './report.routes'
import {WarrantyRoutes} from './warranty.routes'

const Error404 = lazy(() => import('pages/errors/ErrorsPage'))

export const AppRouteList: IAppRoutes[] = [
  {
    link: DASHBOARD,
    element: lazy(() => import('pages/dashboard/DashboardPage')),
  },
  {
    link: HELP,
    element: lazy(() => import('pages/help/HelpPage')),
  },
  {...MasterdataRoutes},
  {...AssetRoutes},
  {...ProcurementRoutes},
  {...WarrantyRoutes},
  {...LicenseRoutes},
  {...LicenseExpiryRoutes},
  {...InventoryRoutes},
  {...LowStockRoutes},
  {...ReportRoutes},
  {...NotificationRoutes},
  {
    link: 'auth/*',
    redirect: DASHBOARD,
  },
  {
    link: '*',
    element: Error404,
  },
]
